export default "__VITE_ASSET__7e4e3fac__"